import { Components, Theme } from '@mui/material/styles';

export const muiFormLabelOverride: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontWeight: 500,
      color: theme.vars.palette.text.primary,
      '&.Mui-focused': {
        color: theme.vars.palette.text.primary,
      },
    }),
  },
};
